import { Directive, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';
import { ResponsiveUIService } from '../services/responsive-ui.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appResponsiveHeight]',
  standalone: true
})
export class ResponsiveHeightDirective {

  @Input() desktopHeight = '26vh';
  @Input() mobileHeight = '41vh';
  
  private subscription!: Subscription;

  constructor(
    private el: ElementRef,
    private responsiveSrv: ResponsiveUIService
  ) {}

  ngOnInit() {
    this.subscription = this.responsiveSrv.getDeviceStatus().subscribe((deviceStatus: string) => {
      if (deviceStatus === 'lg' || deviceStatus === 'md' || deviceStatus === 'xlg') {
        this.el.nativeElement.style.height = this.desktopHeight;
      } else {
        this.el.nativeElement.style.height = this.mobileHeight;
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
